import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/browser';
import { captureMessage } from '@sentry/browser';
import logger from 'lib/logger';
import { sendXray } from 'reactApp/utils/ga';
import createSagaMiddleware from 'redux-saga';
import createSentryMiddleware from 'redux-sentry-middleware';

import reducers from './reducers';

const sagaMiddleware = createSagaMiddleware({
    onError: (error: Error) => {
        logger.error(`saga root exception: ${error?.toString()}`, error);
        sendXray(['exceptions', 'sagaroot']);
        captureMessage('saga root exception', {
            // @ts-ignore
            extra: error,
        });
    },
});

const middleware = [
    ...getDefaultMiddleware({
        serializableCheck: false,
        // immutableCheck работает очень долго при подгрузке порции в деве
        // договорились включать руками, если надо будет дебажить
        immutableCheck: false,
    }),
    createSentryMiddleware(Sentry, {
        stateTransformer: () => {
            //
        },
    }),
    sagaMiddleware,
];

export const store = configureStore({
    reducer: reducers,
    middleware,
});

export type RootState = ReturnType<typeof reducers>;
export type AppDispatch = typeof store.dispatch;

export const initSaga = (rootSaga) => {
    sagaMiddleware.run(rootSaga);
};
